const orderDetailsMapper = ({ deliveryAgreement, spotVolume }) => ({
  deliveryAgreement,
  spotVolume,
});

export { orderDetailsMapper };
